import { Historical } from "@customTypes/responses/lawsuit";
import { StandardTheme } from "@nectarTypes";
import { useTheme } from "emotion-theming";
import { FaUser } from "@react-icons/all-files/fa/FaUser";
import { FaCloudDownloadAlt } from "@react-icons/all-files/fa/FaCloudDownloadAlt";
import { FaFileAlt } from "@react-icons/all-files/fa/FaFileAlt";
import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";
import React from "react";

type MovementIconProps = {
  historicalType: Historical["type"];
};

const HistoricalIcon: React.FC<MovementIconProps> = ({ historicalType }) => {
  const theme = useTheme<StandardTheme>();

  const iconColor = theme.colors.gray500;

  switch (historicalType) {
    case "DONE_TASK":
      return <FaCheckCircle color={iconColor} />;
    case "CLIPPING":
      return <FaFileAlt color={iconColor} />;
    case "MANUALLY":
      return <FaUser color={iconColor} />;
    case "AUTOMATIC_LAWSUIT":
      return <FaCloudDownloadAlt color={iconColor} />;
    default:
      return <FaCloudDownloadAlt color={iconColor} />;
  }
};

export default HistoricalIcon;
